// Modules
import React, { useContext, useMemo } from 'react'

// Components
import Page from 'components/layout/page/Page'

// Context
import Data from 'context/Data'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'
import useNavigateWithParameters from 'hooks/external/useNavigateWithParameters'

// Helpers
import { checkIfUserIsCompanyTester } from 'helpers/test'

// Data
import products from 'data/products'

// Styles
import './Services.scss'

// Data (Temporary)
const services = ['belesprit', 'studio', 'admin'] // NOTE: Order of array matters
const publicServices = ['belesprit', 'studio']

// View: Hub > Landing > Services
function Services () {
	// Data
	const { account } = useContext(Data)
	// const { translate } = useLanguage('pages.hub.views.landing.sections.services')
	const { navigateWithParameters } = useNavigateWithParameters()

	// Data (Memoized)
	const displayedServices = useMemo(() => {
		if (!account?.email) return services.filter(service => publicServices.includes(service))
		const isUserCompanyTester = checkIfUserIsCompanyTester(account?.email)
		if (isUserCompanyTester) return services
		else return services.filter(service => publicServices.includes(service))
	}, [account?.email])

	// Render
	return (
		<Page.Section
			willGrow
			name="services">
			{displayedServices.length > 0 &&
				<ul className="aix-services">
					{displayedServices.map(service => (
						<li
							key={service}
							className="aix-service">
							<a
								className="aix-link"
								onClick={() => (
									!!products[service]?.tokenType
										? navigateWithParameters(products[service].url, products[service].tokenType)
										: window.location.href = products[service].url
								)}>
								<img
									className="aix-visual"
									src={`/images/products/${service}.png`} />
								<span className="aix-name">{products[service]?.name || '-'}</span>
							</a>
						</li>
					))}
				</ul>
			}
		</Page.Section>
	)
}

// Export
export default Services
